<ng-container *ngIf="permConfig.isAddAllowed || permConfig.isEditAllowed">
    <div class="container-fluid">
        <app-page-title [title]="editMode? 'Edit DRS': 'Add DRS'"></app-page-title>
        <form [formGroup]="drsForm" (ngSubmit)="addDrs()" (keydown.enter)="useEnterKey ? $event.preventDefault() : addDrs()">
            <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase">Info</div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2" *ngIf="editMode">
                            <div class="mb-2">
                                <label for="drsNo" class="form-label">DRS No.</label>
                                <input #drsNo type="text" class="form-control form-control-sm" formControlName="txtDrsNo"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || drsForm.get('txtDrsNo')?.touched) && drsForm.get('txtDrsNo').errors}" 
                                    (keydown.enter)="useEnterKey && drsForm.get('txtDrsNo').valid ? drsDate.focus() : drsForm.get('txtDrsNo').markAsTouched()">
                                <div *ngIf="(isFormSubmitted || drsForm.get('txtDrsNo')?.touched) && drsForm.get('txtDrsNo').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="drsForm.get('txtDrsNo').errors.required">DRS no. is Required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                              <label for="dateTime" class="form-label">DRS Date<span class="mandatory">*</span></label>
                              <input #drsDate type="datetime-local" class="form-control form-control-sm" formControlName="txtDateTime"
                                [min]="minDateTime" max="3000-12-31T23:59" (input)="validateDate()"
                                [ngClass]="{'is-invalid': (isFormSubmitted || drsForm.get('txtDateTime')?.touched) && drsForm.get('txtDateTime').errors}"  
                                (keydown.enter)="useEnterKey && drsForm.get('txtDateTime').valid ? fieldExecutive.focus() : drsForm.get('txtDateTime').markAsTouched()"/>
                              <div *ngIf="(isFormSubmitted || drsForm.get('txtDateTime')?.touched) && drsForm.get('txtDateTime').errors"
                                class="invalid-feedback">
                                <!-- <span *ngIf="drsForm.get('txtDateTime').errors.minDate">Date and Time must be valid</span> -->
                                <span *ngIf="drsForm.get('txtDateTime').errors.required">Date and Time is required</span>
                              </div>
                            </div>
                          </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="fieldExecutive" class="form-label">Field Executive</label>
                                <ng-select #fieldExecutive id="fieldExecutive" [items]="fieldExecutiveList" bindLabel="username" placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                    formControlName="ddlFieldExecutive" 
                                    (keydown.enter)="useEnterKey && company.focus()">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="company" class="form-label">Company
                                </label>
                                <ng-select #company class="form-control form-control-sm" formControlName="ddlCompany"
                                    id="company" [items]="companyList" bindLabel="name" [bindValue]="'id'"
                                    placeholder="select" [appendTo]="'body'" [openOnEnter]="false"
                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                    (keydown.enter)="useEnterKey && vehicleType.focus()">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="vehicleType" class="form-label">Vehicle Type</label>
                                <ng-select #vehicleType id="vehicleType" [items]="vehicleTypeList" bindLabel="name"
                                    placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                    formControlName="ddlVehicleType" 
                                    (keydown.enter)="useEnterKey && vehicleName.focus()">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="vehicleName" class="form-label">Vehicle Name</label>
                                <input #vehicleName id="fieldExecutive" class="form-control form-control-sm"
                                    formControlName="txtVehicleName" 
                                    (keydown.enter)="useEnterKey && vehicleOwner.focus()">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="vehicleOwner" class="form-label">Vehicle Owner</label>
                                <input #vehicleOwner id="vehicleOwner" type="text" class="form-control form-control-sm"
                                    formControlName="txtVehicleOwner" 
                                    (keydown.enter)="useEnterKey && vomContactNo.focus()">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="vomContactNo" class="form-label">Owner Contact No.</label>
                                <input #vomContactNo id="vomContactNo" type="number" class="form-control form-control-sm"
                                    formControlName="txtVOMContact" appLimitDigits [length] = "10"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || drsForm.get('txtVOMContact')?.touched) && drsForm.get('txtVOMContact').errors}" 
                                    (keydown.enter)="useEnterKey && drsForm.get('txtVOMContact').valid ? driverName.focus() : drsForm.get('txtVOMContact').markAsTouched()">
                                <div *ngIf="(isFormSubmitted || drsForm.get('txtVOMContact')?.touched) && drsForm.get('txtVOMContact').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="drsForm.get('txtVOMContact').errors.pattern">Must be of 10 Digit</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="driverName" class="form-label">Driver Name</label>
                                <input #driverName id="driverName" type="text" class="form-control form-control-sm" formControlName="txtDriver" 
                                (keydown.enter)="useEnterKey && dContactNo.focus()">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="dContactNo" class="form-label">Driver Contact No.</label>
                                <input #dContactNo id="dContactNo" type="number" class="form-control form-control-sm"
                                    formControlName="txtDContact" appLimitDigits [length] = "10"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || drsForm.get('txtDContact')?.touched) && drsForm.get('txtDContact').errors}" 
                                    (keydown.enter)="useEnterKey && drsForm.get('txtDContact').valid ? (!editMode? awbNoRef.nativeElement.focus(): submitBtn.nativeElement.focus()) : drsForm.get('txtDContact').markAsTouched()">
                                <div *ngIf="(isFormSubmitted || drsForm.get('txtDContact')?.touched) && drsForm.get('txtDContact').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="drsForm.get('txtDContact').errors.pattern">Must be of 10 Digit</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase">Manage Items</div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="mb-2">
                                <label for="awbNo" class="form-label">AWB No.<span class="mandatory">*</span></label>
                                        <div class="input-group">
                                            <input #awbNoRef formControlName="txtAwbNo" type="text" class="form-control col form-control-sm"
                                                placeholder="Type to search" 
                                                [ngbTypeahead]="searchAWBNumber" [resultTemplate]="rt"
                                                [inputFormatter]="AWBFormatter"  maxlength="30" 
                                                (keydown.enter)="useEnterKey && addItemsBtn.nativeElement.focus()"/>
                                        </div>
                                        <ng-template #rt let-r="result" let-t="term">
                                            <ngb-highlight [result]="r.awbnumber" [term]="t"></ngb-highlight>
                                            <!-- <span> | {{r['id']}}</span> -->
                                        </ng-template>
                                <!-- <ng-select #drsNo id="awbNo" [items]="filteredAwbList" bindLabel="awbnumber"
                                    placeholder="Select" [bindValue]="'awbnumber'" [appendTo]="'body'" [openOnEnter]="false"
                                    formControlName="txtAwbNo" 
                                    (change)="onSelectForwardingORAwbNo('awb')"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || drsForm.get('txtAwbNo')?.touched) && drsForm.get('txtAwbNo').errors}">
                                </ng-select> -->
                                <!-- <div *ngIf="(isFormSubmitted || drsForm.get('txtAwbNo')?.touched) && drsForm.get('txtAwbNo').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="drsForm.get('txtAwbNo').errors.required">AWB No. is
                                        required</span>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-md-2 mt-3">
                            <div class="mb-2 mt-1">
                                <div *ngIf="!isListEdit">
                                    <button #addItemsBtn type="button" class="btn btn-primary btn-sm" (click)="addItems()" (keydown.enter)="addItems()">
                                        <i class="mdi mdi-plus"></i>
                                        Add
                                    </button>
                                </div>
                                <!-- <div *ngIf="isBagEdit">
                                    <button type="button" class="btn btn-primary btn-sm">
                                        Update
                                    </button>
                                    <button type="button" class="btn btn-secondary btn-sm">
                                        Cancel
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-1">
                        <label class="form-label custom-info-label">
                            <i class="mdi mdi-alert-circle-outline me-1">
                            Note: You can delete record from the grid and click "Update" button to update the DRS
                            </i> 
                        </label>
                    </div>
                    <div class="col-md-12 grid-container">
                        <ag-grid-angular #agGrid style="width: 100%; height: 80%" id="myGrid"
                            class="ag-theme-balham" [rowData]="selectedAWBList" [columnDefs]="columnDefs"
                            [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                            [suppressMenuHide]="true" [gridOptions]="gridOptions" [enableCellTextSelection]="true"
                            (gridReady)="onGridReady($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">
                    <div class="button-items">
                        <button #submitBtn *ngIf="!isDelivered" type="submit" class="btn btn-primary w-sm" (keydown.enter)="addDrs()">{{editMode? 'Update': 'Create'}}</button>
                        <a routerLink="/operation/drs"><button type="button"
                                class="btn btn-secondary w-sm">Cancel</button></a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>

<ng-container *ngIf="!permConfig.isAddAllowed ||!permConfig.isEditAllowed">
    <app-forbidden></app-forbidden>
</ng-container>